import { Typography } from "@mui/material";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import { useParams, useSearchParams } from "react-router-dom";
import RequestsTabPanels from "../components/RequestsTabPanels/RequestsTabPanels";
import { tabs } from "../api/models/RequestsTabs";

const RequestsList = () => {
  const { tab } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search");
  
  return (
    <>
      <TopBar>
        <Typography variant="h4">Requests</Typography>
      </TopBar>

      <RequestsTabPanels 
        routeTabIndex={tabs.indexOf(tab || "pending")} 
        searchQuery={searchQuery || undefined}
      />
    </>
  );
};

export default RequestsList;
